import ProtectedWrapper from './ProtectedWrapper';

export default ProtectedWrapper;
